var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "t_copy_2",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "t copy 2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.0078 55.78a3.0015 3.0015 0 0 1 -2.6-4.5025l23.9922-41.5563a3.0016 3.0016 0 0 1 5.1992 0l23.9926 41.5561a3.0015 3.0015 0 0 1 -2.6 4.5025z",
    fill: "#ffd21e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#373737"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32 9.22a1.9662 1.9662 0 0 1 1.7333 1.0007l23.9926 41.5568a2.0015 2.0015 0 0 1 -1.7333 3.0025h-47.9852a2.0015 2.0015 0 0 1 -1.7333-3.0022l23.9926-41.5568a1.9663 1.9663 0 0 1 1.7333-1.001m0-2a3.9641 3.9641 0 0 0 -3.4654 2.001l-23.9925 41.5565a4.0014 4.0014 0 0 0 3.4653 6.0025h47.9852a4.0014 4.0014 0 0 0 3.4653-6.0022l-23.9925-41.5568a3.9641 3.9641 0 0 0 -3.4654-2.001z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 46.993,
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    height: 20,
    rx: 2,
    width: 4,
    x: 30,
    y: 20.993
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.87b4f83cc80b43db9537f8e8e52240f3.svg";
export { ForwardRef as ReactComponent };